import * as React from "react";
import type { SVGProps } from "react";
const SvgFamily = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#family_svg__a)">
      <path d="M6 22a1 1 0 0 1-1-1v-5a1 1 0 0 1 .29-.71l.71-.7V11H3v3.59l.71.7A1 1 0 0 1 4 16v5a1 1 0 1 1-2 0v-4.59l-.71-.7A1 1 0 0 1 1 15v-4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v4a1 1 0 0 1-.29.71l-.71.7V21a1 1 0 0 1-1 1M20 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.61l-1.56-4.68A1.2 1.2 0 0 1 19 11h-2a1 1 0 0 1-2 0 2 2 0 0 1 2-2h2a2 2 0 0 1 2 1.81l2 5.87a1 1 0 0 1-.14.9A1 1 0 0 1 22 18h-1v3a1 1 0 0 1-1 1M4.5 8A2.51 2.51 0 0 1 2 5.62l-.06-1A2.53 2.53 0 0 1 4.45 2a2.56 2.56 0 0 1 2.63 2.53L7 5.62A2.51 2.51 0 0 1 4.5 8m.05-4a.56.56 0 0 0-.63.53l.06 1A.52.52 0 0 0 4.5 6a.52.52 0 0 0 .5-.49l.06-1A.53.53 0 0 0 4.55 4" />
      <path d="M14 22a1 1 0 0 1-1-1v-3a1 1 0 0 1 .29-.71l.71-.7V14h-3v2.59l.71.7A1 1 0 0 1 12 18v3a1 1 0 1 1-2 0v-2.59l-.71-.7A1 1 0 0 1 9 17v-3a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a1 1 0 0 1-.29.71l-.71.7V21a1 1 0 0 1-1 1M12.5 11A2.51 2.51 0 0 1 10 8.62l-.06-1A2.53 2.53 0 0 1 12.45 5a2.56 2.56 0 0 1 2.63 2.53L15 8.62A2.51 2.51 0 0 1 12.5 11m.05-4a.56.56 0 0 0-.63.53l.06 1a.52.52 0 0 0 .52.47.52.52 0 0 0 .5-.49l.06-1a.53.53 0 0 0-.51-.51M18 8a2.51 2.51 0 0 1-2.51-2.38l-.06-1A2.53 2.53 0 0 1 18 2a2.56 2.56 0 0 1 2.63 2.53l-.07 1.09A2.51 2.51 0 0 1 18 8m.05-4a.56.56 0 0 0-.63.53l.06 1A.52.52 0 0 0 18 6a.52.52 0 0 0 .52-.49l.06-1a.53.53 0 0 0-.53-.51" />
    </g>
    <defs>
      <clipPath id="family_svg__a">
        <path fill="#fff" d="M1 2h22v20H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFamily;
